import { useState, useEffect, useRef } from "react";
import Tooltip from "../Tooltip/Tooltip";
import { gsap } from "gsap";
import "./RadioGroup.css";

const RadioGroup = ({
  title,
  name,
  options = [],
  value: controlledValue,
  defaultValue,
  onChange,
  error
}) => {
  const [selected, setSelected] = useState(defaultValue || "");
  const radioRefs = useRef({});

  useEffect(() => {
    if (controlledValue !== undefined) {
      setSelected(controlledValue);
    }
  }, [controlledValue]);

  const handleChange = (event) => {
    const val = event.target.value;
    setSelected(val);
    onChange?.(val);

    // animação de pulse no rádio selecionado
    const radio = radioRefs.current[val];
    if (radio) {
      gsap.fromTo(
        radio,
        { scale: 1 },
        { scale: 1.3, duration: 0.15, yoyo: true, repeat: 1, ease: "power1.inOut" }
      );
    }
  };

  return (
    <div className="radio-container">
      {title && <label className="radio-title">{title}</label>}
      <div className="radio-group">
        {options.map((opt) => (
          <label
            key={opt.value}
            className={`radio-label ${error ? "radio-error" : ""}`}
          >
            <input
              ref={(el) => (radioRefs.current[opt.value] = el)}
              className="radio-input"
              type="radio"
              name={name}
              value={opt.value}
              checked={selected === opt.value}
              onChange={handleChange}
            />
            {opt.label}
            {/*{opt.description && <Tooltip className='radio-tooltip' description={opt.description} />} */}
          </label>
        ))}
      </div>
      {error && <div className="radio-error-message">{error}</div>}
    </div>
  );
};

export default RadioGroup;
